import React from 'react'

import { useSnackbarActions } from 'redux/actions/Snackbar'
import { useAnalysisRerun } from 'redux/hooks/AnalysisGenerations'
import { TAnalysis } from 'redux/hooks/Analyses'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'

import RunningAnalysis from 'components_new/organisms/dialogs/AnalysisDialog/RunningAnalysis'

import { SnackbarMessage } from 'types/GlobalSnackbar'

interface AnalysisRerunningProps {
  analysis: TAnalysis
}

/**
 * The run state in place of the analysis while it is rerun. A cancel
 * leaves the analysis as it was, which only a notice says.
 */
const AnalysisRerunning = (props: AnalysisRerunningProps) => {
  const { analysis } = props

  const { t } = useTranslation()
  const { generation, cancel } = useAnalysisRerun(analysis)
  const { toggleSnackbarOpen } = useSnackbarActions()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <RunningAnalysis
        id={analysis.analysis_type_id}
        inline={true}
        startedAt={generation?.created_at ?? null}
      />
      <Button
        color="error"
        fullWidth={true}
        onClick={() =>
          cancel(() =>
            toggleSnackbarOpen(SnackbarMessage.AnalysisRerunCancelled)
          )
        }
        variant="outlined"
      >
        {t('analysis_types', 'cancel_run')}
      </Button>
    </Box>
  )
}

export default AnalysisRerunning
